"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheaterType = void 0;
var CheaterType;
(function (CheaterType) {
    CheaterType["DECRYPT_ROUND_ID"] = "DECRYPT_ROUND_ID";
    CheaterType["DECRYPT_KEY"] = "DECRYPT_KEY";
    CheaterType["MAX_SCORE"] = "MAX_SCORE";
    CheaterType["MAX_PER_SECOND"] = "MAX_PER_SECOND";
    CheaterType["MIN_PER_SECOND"] = "MIN_PER_SECOND";
    CheaterType["GAME_TIME_DIFFERENCE"] = "GAME_TIME_DIFFERENCE";
    CheaterType["TIME_LESS_THEN_ZERO"] = "TIME_LESS_THEN_ZERO";
    CheaterType["MANUAL"] = "MANUAL";
    CheaterType["DUPLICATE_ROUND_ID"] = "DUPLICATE_ROUND_ID";
})(CheaterType || (exports.CheaterType = CheaterType = {}));
